/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumPatientContactType = "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type ListPatientContacts_EmbedPatient = {
    readonly doNotContact: boolean | null;
    readonly contact: ReadonlyArray<{
        readonly active: boolean | null;
        readonly type: EnumPatientContactType | null;
        readonly value: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ListItemPatientContact_EmbedPatientContact">;
    } | null> | null;
    readonly " $refType": "ListPatientContacts_EmbedPatient";
};
export type ListPatientContacts_EmbedPatient$data = ListPatientContacts_EmbedPatient;
export type ListPatientContacts_EmbedPatient$key = {
    readonly " $data"?: ListPatientContacts_EmbedPatient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListPatientContacts_EmbedPatient">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListPatientContacts_EmbedPatient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doNotContact",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PatientContact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "active",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemPatientContact_EmbedPatientContact"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
(node as any).hash = '2fd634c44fd49306b44268f47052a74e';
export default node;
